/** Music Moments copy, mirrored in iOS MusicStrings.swift. */
export const musicStrings = {
  title: 'Music Moments', library: 'Your moments', add: 'Add moment', edit: 'Edit moment', editAction: 'Edit',
  save: 'Save', cancel: 'Cancel', back: 'Back', delete: 'Delete', favorite: 'Favorite',
  actions: 'Moment actions',
  deleteTitle: 'Delete this moment?', deleteBody: 'This moment and its recording will be permanently deleted.',
  name: 'What did you work on?', namePlaceholder: 'A song, idea, or something you learned',
  momentStep: 'Moment', notesStep: 'Notes', next: 'Next', previous: 'Back',
  details: 'Details', activityDetail: 'Activities', timeSpent: 'Time spent', minutes: 'min',
  missingName: 'Add a name for this moment before saving.',
  date: 'Date', activities: 'How did you make music?', instrument: 'Instrument (optional)',
  duration: 'Time spent (minutes, optional)', notes: 'What did you learn or notice?',
  empty: 'No music moments yet', emptyDetail: 'Save something you played, sang, or created.',
  noMatches: 'No matching moments', search: 'Search music moments',
  loadMore: 'Load more', saving: 'Saving...',
  activityLabels: { playing: 'Playing', singing: 'Singing', creating: 'Creating' },
  instrumentOptions: ['Piano', 'Keyboard', 'Acoustic guitar', 'Electric guitar', 'Bass', 'Drums', 'Violin', 'Ukulele', 'Flute', 'Saxophone'],
  recording: 'Recording (optional)', chooseAudio: 'Choose audio file', removeAudio: 'Remove audio',
  audioReady: 'Audio ready to save', audioTooLarge: 'Choose an audio file under 6 MB.',
  replaceAudioHint: 'A recording is attached. Record or choose a new clip to replace it.',
  audioTooLong: 'Choose an audio clip up to one minute.', audioUnsupported: 'Choose an M4A, MP3, or WAV audio file.',
  audioUploadFailed: 'Your moment was saved, but the recording could not upload. Try saving again.',
  retryAudio: 'Retry upload',
};
